import { getRTFInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { Trans } from "react-i18next";
import { DashedText } from "../../elements/DashedText";
import { RTF } from "../../elements/RTF";
import {
  getAlt,
  getLinkFromContentBlock,
  getLinkTitleFromContentBlock,
  getSvg,
} from "../Blocks";

export const SlideshowSlide: React.FC<{
  slide: Queries.ContentBlockFragment;
  index: number;
  count: number;
}> = ({ slide, index, count }) => {
  const { title } = slide;
  const indexString = `${index + 1}`.padStart(2, "0");
  const countString = `${count}`.padStart(2, "0");
  const link = getLinkFromContentBlock(slide);
  const linkTitle = getLinkTitleFromContentBlock(slide);
  const image = getImage(slide.image);
  const svg = getSvg(slide.image);
  const alt = getAlt(slide.image, title);
  const slideContent = getRTFInformation(slide.message);
  return (
    <section
      data-component="Slideshow Slide"
      className={classNames("relative mb-40px h-full")}
    >
      <div className={classNames("page-grid max-width relative")}>
        <div
          className={classNames(
            "col-span-4 col-start-2",
            "lg:col-span-5 lg:col-start-3 lg:row-span-1 lg:row-start-2"
          )}
        >
          <p className="h6 pb-20px text-hyacinth">
            {indexString} / {countString}
          </p>
          <h3 className="h3 pb-20px lg:pb-60px">{title}</h3>
          {slideContent && (
            <RTF
              className={classNames(link && "pb-20px lg:pb-60px")}
              fixedParagraphClassName="p4"
              content={slideContent}
            />
          )}
          {link && (
            <Link
              to={link}
              className={classNames(
                slide.showLinkAsButton ? "servicesButton" : "read-more flex"
              )}
              aria-label={linkTitle ?? "Learn more"}
            >
              <DashedText colorClassName="text-hyacinth">
                {linkTitle ? linkTitle : <Trans>Learn more</Trans>}
              </DashedText>
            </Link>
          )}
        </div>
        {image && (
          <GatsbyImage
            className={classNames(
              "col-span-full col-start-1 mt-40px",
              "lg:col-span-9 lg:col-start-8 lg:row-span-3 lg:row-start-1 lg:mt-0"
            )}
            objectFit="contain"
            image={image}
            alt={alt}
            loading="lazy"
          />
        )}
        {svg && (
          <img
            className={classNames(
              "col-span-full col-start-1 mt-40px",
              "lg:col-span-9 lg:col-start-8 lg:row-span-3 lg:row-start-1 lg:mt-0"
            )}
            src={svg.encoded ?? svg.encodedUrl}
            alt=""
          />
        )}
      </div>
    </section>
  );
};
